import PageDevEnvSelector from '../components/development/PageDevEnvSelector';

const config = {
    // Default to this component.
    defaultPage: PageDevEnvSelector,

    // The environment selector can choose from:
    availableEnvs: {
        uat: {
            hubEnvironment: 'user-acceptance',
            hubUrl: 'https://hub.uat.flexkids.nl',
        },
        'hub.acc AWS': {
            hubEnvironment: 'hub.acc AWS',
            hubUrl: 'https://hub.acc.flexkids.nl',
        },
    },
};

config.activeEnvironment = config.availableEnvs.uat;

export default config;
